export interface ModelOption {
    id: string;
    name: string;
    badge?: {
        text: string;
        color: string;
    };
}

export interface ModelGroup {
    label: string;
    models: ModelOption[];
}

export const modelGroups: ModelGroup[] = [];
